module.exports = __webpack_public_path__ + "img/premium.4f38b391.png";